"use strict";
var mainImage = document.querySelector("#largeImg");
var list = document.querySelector("#thumbs");
list.addEventListener("click", function(event) {
    var link = event.target.closest(".list-item__link");
    if (!link) return;
    event.preventDefault();
    var miniImg = link.querySelector("img");
    if (miniImg) // mainImage.src = miniImg.src;
    mainImage.src = link.getAttribute("href");
});

//# sourceMappingURL=index.8bba93cb.js.map
